import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Text
} from '@cencosud-cencommerce/paris-uikit';

import { useAppDispatch, useAppSelector } from '@/Application/Hooks/Redux';
import { URL_ROUTES } from '@/constants';
import { useGtmBillingProduct } from '@/modules/perseo-billing/hooks';
import { setIsInvoiceAndGuestModalOpen } from '@/modules/perseo-billing/store/slices/billing';

export const InvoiceAndGuestModal = () => {
  const dispatch = useAppDispatch();
  const isInvoiceAndGuestModalOpen = useAppSelector(
    (state) => state.billing.isInvoiceAndGuestModalOpen
  );

  const { continueWithInvoiceGtm } = useGtmBillingProduct();

  const closeModal = () => {
    setTimeout(() => {
      continueWithInvoiceGtm('Guest');
      dispatch(setIsInvoiceAndGuestModalOpen(false));
    }, 0);
  };

  return (
    <Modal onClose={closeModal} size="md" isOpen={isInvoiceAndGuestModalOpen}>
      <ModalHeader
        icon={{ name: 'warning-circle', fill: 'warning-500' }}
        onClose={closeModal}
        title="¿Quieres pagar con factura?"
      />
      <ModalBody className="co-flex co-flex-col">
        <Text className="co-text-left co-mt-2" weight={500}>
          Por razones de seguridad, para comprar con factura tendrás que iniciar
          sesión o crear una cuenta. Por favor, vuelve al paso{' '}
          <Text
            href={URL_ROUTES.PERSONAL_DETAILS}
            variant="link1"
            weight={500}
            color="primary-500"
          >
            Datos
          </Text>{' '}
          para hacerlo.
        </Text>
      </ModalBody>
      <ModalFooter>
        <Button block onClick={closeModal}>
          Entendido
        </Button>
      </ModalFooter>
    </Modal>
  );
};
